"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BOMItemsList_1 = __importDefault(require("./BOMItemsList"));
exports.default = BOMItemsList_1.default;
